import { all, fork } from 'redux-saga/effects';
import authSaga from './authSaga';
import analysisSaga from './analysisSaga';
import uploadSaga from './uploadSaga';
import reportSaga from './reportSaga';

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(analysisSaga),
    fork(uploadSaga),
    fork(reportSaga),
  ]);
}